import { render, staticRenderFns } from "./ToastNotifications.vue?vue&type=template&id=21c41672&scoped=true"
import script from "./ToastNotifications.vue?vue&type=script&lang=js"
export * from "./ToastNotifications.vue?vue&type=script&lang=js"
import style0 from "./ToastNotifications.vue?vue&type=style&index=0&id=21c41672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c41672",
  null
  
)

export default component.exports